import { HttpClient , HttpHeaders} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DashboardService {

  constructor(private http: HttpClient,private cookies: CookieService) { }

  getClientData(): Observable<any> {
    return this.http.get(`/data`);
  }

  getAccessToken(code: string): Observable<any> {
    return this.http.post(`/authData`, {code});
  }

  getAntsession():Observable<any> {
    return this.http.get(`/getAntSession`);
  }

  cashPosition(clientId: any): Observable<any> {
    return this.http.get(`/cashPositionApi`, { params: { clientcode: clientId } });
  }

  getAccountValue(clientId: any, fromDate: any, toDate: any): Observable<any> {
    return this.http.get(`/day-by-day`, { params: { clientcode: clientId,  start_date: fromDate, end_date: toDate } });
  }

  profitAndLossApi(clientId: any): Observable<any> {
    return this.http.get(`/profitAndLossApiChart`, { params: { clientcode: clientId } });
  }

  getTradeCount(clientId: any): Observable<any> {
    return this.http.get(`/getTradeCount`, { params: { clientcode: clientId } });
  }

  referral(params: any): Observable<any> {
    return this.http.get(`/referral`, { params: { clientcode: params.clientId ,month:params.month,year:params.year}});
  }

  referralOverall(params: any): Observable<any> {
    return this.http.get(`/referralOverall`, { params: { clientcode: params.clientId ,month:params.month,year:params.year} });
  }

  referralBrokerageCount(clientId: any): Observable<any> {
    return this.http.get(`/referralBrokerageCount`, { params: { clientcode: clientId } });
  }

  referralAnalysis(formData: any): Observable<any> {
    return this.http.post(`/referralAnalysis`, formData);
  }

  aliceServey(formData: any): Observable<any> {
    return this.http.post(`/aliceSurvey`, formData);
  }

  getEarnedSaved(clientId: any): Observable<any> {
    return this.http.get(`/getEarnedSaved`, { params: { clientcode: clientId } });
  }

  getRecommandations(): Observable<any> {
    return this.http.get(`/aliceRecommendations`);
  }

  checkDormantStatus(): Observable<any> {
      const baseUrl = environment.apiBaseUrl;
    return this.http.get(`${baseUrl}/dormant/check-dormant-status`);
  }

  // getUploadStatus(): Observable<any> {
  //     const clientId = this.cookies.get('clientId') || '';
  //   return this.http.get(`${environment.ekycUATApiUrl}/financial-proof/get-upload-status`);
  // }

  getUploadStatus(): Observable<any> {

   const baseUrl = environment.apiBaseUrl;
    return this.http.get(`${baseUrl}/financial-proof/get-upload-status`);
}

  accountTraded(formData: any): Observable<any> {
    return this.http.post(`/accountTraded`, formData);
  }

  getNomineeDetails():Observable<any> {
    return this.http.get('/nomineeCheck')
  }

  getFreedomPlan(clientId: any): Observable<any> {
    return this.http.get(`/freedomPlan`);
  }

  // getKraClientStatus(): Observable<any> {
    //    const clientId = this.cookies.get('clientId') || '';
    // const baseUrl = environment.apiBaseUrl;
    // return this.http.get(`${environment.ekycUATApiUrl}/kra-client-notification`);
    // return this.http.get(`${baseUrl}/kra-client-notification`);
  // }

  getZerobrokerageStatus(formData: any): Observable<any> {
    return this.http.post('/zerobrokerage',formData);
  }

  getZerobrokeragenewClientStatus(formData: any): Observable<any> {
    return this.http.post('/zeroBrokerageNewClient',formData);
  }

  getUserNetBalance(): Observable<any> {
    return this.http.post(`/user-netbalance`, {});
  }

  getCleartaxDetails(formaldata:any):Observable<any>{
    return this.http.get(`/cleartaxLogin`,{ params: { email: formaldata }} );
  }

  getPortfolioscorece():Observable<any>{
    return this.http.get(`/portfolioScore`);
  }

  getfinancecheck():Observable<any>{
       const baseUrl = environment.apiBaseUrl;
    // return this.http.post(`${environment.ekycUATApiUrl}/financial-proof/get-popup-status`,{})
    return this.http.post(`${baseUrl}/financial-proof/get-popup-status`,{})
  }

  // new-dashboard
  getSectorWiseHoldings(sectorName:any):Observable<any>{
    return this.http.get(`/sectorWiseHoldings`,{ params: { sector_name: sectorName }} );
  }

  getSwotAnalysis(isin:any):Observable<any>{
    return this.http.get(`/getTrendLyneSwotData`,{ params: { isin: isin  }} );
  }
  
  getMarketCapWiseHoldings(stockGroup: string):Observable<any>{
    return this.http.get(`/marketCapWiseHoldings`);
  }

  // de-stat

getFetchsession(antsession: string): Observable<any> {
  const headers = new HttpHeaders({
    Authorization: `Bearer ${atob(antsession)}`
  });

  return this.http.post(
    `${environment.riseapi}/auth/fetchSession`,
    { ant_session: "abc" },
    { headers }
  );
}

mfcStatus(accessToken: string, clientId: string): Observable<any> {
  const headers = new HttpHeaders({
    Authorization: `Bearer ${accessToken}`
  });
  return this.http.post(
    `${environment.riseapi}/mfcentral/mfcStatus`,
    { clientId },
    { headers }
  );
}

mfcRequest(accessToken: string, clientId: string): Observable<any> {
  const headers = new HttpHeaders({
    Authorization: `Bearer ${accessToken}`
  });
  return this.http.post(
    `${environment.riseapi}/mfcentral/mfcRequest`,
    { clientId },
    { headers }
  );
}

mfcValidateQR(accessToken: string, clientId: string, qrCode: string): Observable<any> {
  const headers = new HttpHeaders({
    Authorization: `Bearer ${accessToken}`
  });
  return this.http.post(
    `${environment.riseapi}/mfcentral/mfcValidateQR`,
    { clientId, qrCode },
    { headers }
  );
}

getDestatlist():Observable<any>{
    return this.http.get(`/de-stat-listing`);
  }

  getDesubmitlist():Observable<any>{
    return this.http.get(`/de-stat-submitted-list`)
  }

  getInsertdestat(params:any):Observable<any> {
    return this.http.post(`/de-stat-insert`,params)
  }

// newMfcData(accessToken: string, clientId: string, page = 0, pageSize = 10): Observable<any> {
//   const headers = new HttpHeaders({
//     Authorization: `Bearer ${accessToken}`
//   });
//   return this.http.post(
//     `${environment.riseapi}/mfcentral/newMfcData?page=${page}&pageSize=${pageSize}`,
//     { clientId },
//     { headers }
//   );
// }

}
